module.exports = __webpack_public_path__ + "static/media/logo-wbs-coding-school.dd0cdc10.svg";